var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"wyPageModal",staticClass:"wy-page-modal-wrapper"},[(_vm.showModal)?_c('transition',{attrs:{"name":"wy-page-modal"}},[_c('div',{staticClass:"wy-page-modal"},[_vm._t("default")],2)]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }